import { useQuery } from "@tanstack/react-query";
import { api } from "./api";
import type { Season } from "../shared/seasons";

export { activeSeasonOf, clampDate, seasonOfDate } from "../shared/seasons";
export type { Season };

export const jstToday = () => new Intl.DateTimeFormat("sv-SE", { timeZone: "Asia/Tokyo", year: "numeric", month: "2-digit", day: "2-digit" }).format(new Date());

export const seasonsQuery = { queryKey: ["seasons"], queryFn: () => api<{ rows: Season[] }>("/api/seasons"), staleTime: 60_000 } as const;

export function useSeasons() {
  const query = useQuery(seasonsQuery);
  return { seasons: query.data?.rows ?? [], isLoading: query.isLoading };
}
